module.exports = __webpack_public_path__ + "img/RCCGlogo.56975a02.png";